import React from 'react'
import { Route } from 'react-router'
import start, { AppMain } from './public/App'
import Form from 'Tyan/public/components/Form/Form'

import Login from './business/Login'
import ForgetPassword from './business/ForgetPassword'
import SetPassword from './business/SetPassword'
import ChangePasswordUnLogin from './business/ChangePasswordUnLogin'
import WeixinLayout from './business/WeixinLayout'
import InstrumentQuery from './business/Weixin/InstrumentQuery'
import InstrumentInfo from './business/Weixin/InstrumentInfo'
import InstrumentUsageQuery from './business/Weixin/InstrumentUsageQuery'
import InstrumentUsageInfo from './business/Weixin/InstrumentUsageInfo'

const App = (props) => {
	return <AppMain {...props}>
		<Route exact path="/Login" component={Login} />
		<Route exact path="/ForgetPassword" component={ForgetPassword} />
		<Route exact path="/SetPassword/:token" component={SetPassword} />
		<Route exact path="/ChangePasswordUnLogin/:name" component={ChangePasswordUnLogin} />
		<Route exact path="/InstrumentQuery/:query" component={InstrumentQuery} />
		<Route exact path="/InstrumentInfo/:id" render={props => <InstrumentInfo {...props} showBody={Form} />} />
		<Route exact path="/InstrumentUsageQuery/:query" component={InstrumentUsageQuery} />
		<Route exact path="/InstrumentUsageInfo/:query/:id" render={props => <InstrumentUsageInfo {...props} showBody={Form} />} />
		<Route path="/QYWX/" component={WeixinLayout} />
	</AppMain>
}

Tyan.onReady(() => {
	Tyan.menus.version = 2
	Tyan.hideMyTasks = true
	require('./menus')
	start({ App, title: '亚大汽车实验室', systemName: "亚大汽车实验室", companyName: "" })
})  